import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { getBaseURL } from "../../services/api";
import { parseMatchTime } from "../../utils/dateUtils";

const API_URL = getBaseURL();

const AnnouncePlaying11 = () => {
  const [matches, setMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState("");
  const [team1Players, setTeam1Players] = useState([]);
  const [team2Players, setTeam2Players] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [matchDetails, setMatchDetails] = useState(null);
  
  const token = localStorage.getItem("adminToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) navigate("/winrox11-super-admin");
    else fetchMatches();
  }, [token, navigate]);

  const fetchMatches = async () => {
    try {
      const res = await axios.get(`${API_URL}/admin/matches/live-upcoming`, { headers: { Authorization: `Bearer ${token}` } });
      setMatches(res.data);
    } catch (err) { console.error(err); }
  };

  const handleMatchSelect = async (e) => {
    const matchId = e.target.value;
    setSelectedMatch(matchId);
    if (!matchId) return;

    const matchObj = matches.find(m => m.match_id === matchId);
    setMatchDetails(matchObj);

    try {
      const res = await axios.get(`${API_URL}/admin/players/${matchId}`, { headers: { Authorization: `Bearer ${token}` } });
      const allPlayers = res.data;
      
      setTeam1Players(allPlayers.filter(p => p.team === matchObj.team1));
      setTeam2Players(allPlayers.filter(p => p.team === matchObj.team2));
    } catch (err) { console.error(err); }
  };

  const togglePlayerStatus = (playerId, teamStr) => {
    if (teamStr === 'team1') {
      setTeam1Players(team1Players.map(p => p.player_id === playerId ? { ...p, is_playing: !p.is_playing } : p));
    } else {
      setTeam2Players(team2Players.map(p => p.player_id === playerId ? { ...p, is_playing: !p.is_playing } : p));
    }
  };

  const handleSaveLineup = async () => {
    setIsSaving(true);
    const playingIds = [
      ...team1Players.filter(p => p.is_playing).map(p => p.player_id),
      ...team2Players.filter(p => p.is_playing).map(p => p.player_id)
    ];

    if (playingIds.length !== 22) {
      if(!window.confirm(`Warning: You have selected ${playingIds.length} players instead of exactly 22. Save anyway?`)) {
        setIsSaving(false);
        return;
      }
    }

    try {
      await axios.put(`${API_URL}/admin/players/playing11`, { match_id: selectedMatch, playing_player_ids: playingIds }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert("✅ Playing 11 announced successfully! UI will now show green indicators.");
    } catch (err) {
      alert("❌ Failed to save lineup");
    }
    setIsSaving(false);
  };

  return (
    <div className="admin-body" style={{ padding: "30px", fontFamily: "sans-serif", maxWidth: "900px", margin: "0 auto" }}>
      <Link to="/winrox11-super-admin/dashboard" style={{ color: "blue", textDecoration: "none" }}>← Back to Dashboard</Link>
      <h2 style={{ color: "#d69e2e" }}>📣 Announce Playing 11</h2>
      
      <select value={selectedMatch} onChange={handleMatchSelect} style={{ padding: "10px", width: "100%", marginBottom: "20px", border: "2px solid #ecc94b", borderRadius: "8px" }}>
        <option value="">-- Select Match --</option>
        {matches.map(m => (
          <option key={m.match_id} value={m.match_id}>{m.team1} vs {m.team2} ({parseMatchTime(m).toLocaleString()})</option>
        ))}
      </select>

      {selectedMatch && matchDetails && (
        <div style={{ background: "#fefcbf", padding: "20px", borderRadius: "8px" }}>
          
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px", borderBottom: "2px solid #ccc", paddingBottom: "10px" }}>
            <h3>Toss Time Checklist</h3>
            <button onClick={handleSaveLineup} disabled={isSaving} style={{ padding: "10px 20px", background: "green", color: "white", border: "none", borderRadius: "5px", cursor: isSaving ? "wait" : "pointer", fontWeight: "bold" }}>
              {isSaving ? "Saving..." : "✅ SAVE PLAYING 11 LINEUP"}
            </button>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            {/* Team 1 Column */}
            <div style={{ flex: 1, background: "white", padding: "15px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
              <h3 style={{ color: "#2b6cb0", textAlign: "center", borderBottom: "2px solid #2b6cb0", paddingBottom: "10px" }}>
                {matchDetails.team1} Squad ({team1Players.filter(p => p.is_playing).length}/11 Playing)
              </h3>
              {team1Players.map(p => (
                <div key={p.player_id} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
                  <input type="checkbox" checked={p.is_playing || false} onChange={() => togglePlayerStatus(p.player_id, 'team1')} style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                  <span style={{ fontWeight: p.is_playing ? "bold" : "normal", color: p.is_playing ? "green" : "gray" }}>{p.player_name} ({p.role})</span>
                </div>
              ))}
            </div>

            {/* Team 2 Column */}
            <div style={{ flex: 1, background: "white", padding: "15px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
              <h3 style={{ color: "#e53e3e", textAlign: "center", borderBottom: "2px solid #e53e3e", paddingBottom: "10px" }}>
                {matchDetails.team2} Squad ({team2Players.filter(p => p.is_playing).length}/11 Playing)
              </h3>
              {team2Players.map(p => (
                <div key={p.player_id} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
                  <input type="checkbox" checked={p.is_playing || false} onChange={() => togglePlayerStatus(p.player_id, 'team2')} style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                  <span style={{ fontWeight: p.is_playing ? "bold" : "normal", color: p.is_playing ? "green" : "gray" }}>{p.player_name} ({p.role})</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default AnnouncePlaying11;
